import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from 'chart.js';
import 'chartjs-plugin-style';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
);
const AccountChart = () => {
  const data = {
    labels: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    datasets: [
      {
        label: 'Sales',
        data: [0, 140, 100, 200, 30, 100, 110, 140, 20, 80, 50, 100],
        backgroundColor: 'rgba(159, 119, 235, 1)',
        borderColor: 'rgba(159, 119, 235, 1)',
        borderWidth: 3,

        pointRadius: 0,
        pointHoverRadius: 6,
        pointHitRadius: 10,

        // pointStyle: "rectRot",
        // pointBorderColor: "black",
        lineTension: 0.35,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
      // tooltip: {
      //   shadowOffsetX: 3,
      //   shadowOffsetY: 3,
      //   shadowBlur: 10,
      //   shadowColor: 'rgba(0, 0, 0, 0.5)'
      // }
      tooltip: {
        display: true,
        enabled: true,
        displayColors: false,

        backgroundColor: 'rgba(255, 255, 255, 1)',
        // backgroundColor: "rgba(0, 0, 0, 0.2)",
        // shadow: "0px 0px 11px 4px red",
        padding: 15,
        titleAlign: 'center',
        titleColor: 'rgba(0, 0, 0, 1)',
        titleFont: { weight: '500', family: 'Heebo' },
        bodyAlign: 'center',
        bodyColor: 'rgba(0, 0, 0, 0.6)',
        bodyFont: { weight: '400', family: 'Heebo' },
        caretSize: 7,
        yAlign: 'bottom',
        borderWidth: 5,
        // shadowColor: "red",
        // borderColor: "rgba(0, 0, 0, 0.08)",
        // shadowBlur: 2,
        // borderBox: {
        //   display: true,
        //   color:"red",
        //   // dash: [2, 2],
        // },
      },
    },

    scales: {
      x: {
        display: true,
        border: {
          display: false,
          dash: [2, 2],
        },
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.14)',
          lineWidth: 1,
          drawTicks: false,
          // tickLength: 50,
          // tickColor: "red",
          drawBorder: true,
          drawOnChartArea: true,
        },
        title: {
          display: true,
          text: 'Plan Duration',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            top: 30,
          },
        },
        ticks: {
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
      },
      y: {
        display: true,
        border: {
          display: false,
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: 'No of Scan',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            bottom: 20,
          },
        },
        max: 200,
        min: 0,
        ticks: {
          stepSize: 50,
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };

  return (
    <>
      <h3 style={{ margin: '20px' }}>Account Settings</h3>
      <Grid
        container
        sx={{
          width: '100vw',
          padding: '20px',
        }}
      >
        <Box
          sx={{
            width: '100vw',
            border: '1px solid black ',
            py: '20px',
            px: '30px',
          }}
        >
          <Typography
            sx={{
              mb: '20px',
            }}
          >
            Summary
          </Typography>

          <Box
            sx={{
              height: '300px',
              width: '100%',
              backgroundColor: 'rgba(134, 134, 134, 0.05)',
              // border: "1px solid black ",
            }}
          >
            <Line data={data} options={options} />
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default AccountChart;
